/** Some pickers give a clip an empty or generic type, so its extension decides. */
const VIDEO_EXTENSION = /\.(mp4|mov|m4v|qt|webm|3gp|mkv|avi|mpe?g|ogv|wmv|mts|m2ts)$/i;

/** @param {File} file */
export function isVideoFile(file) {
  const type = String(file.type || '');
  if (type.startsWith('video/')) {
    return true;
  }
  return !type.startsWith('image/') && VIDEO_EXTENSION.test(String(file.name || ''));
}

/**
 * Routes one pick from the composer picker. A message carries photos or one clip, never both.
 *
 * @param {File[]} files the pick, in picker order
 * @param {boolean} hasPhotos the composer already holds photos
 * @returns {{kind: 'photos', files: File[]} | {kind: 'video', file: File} | {kind: 'refused'}}
 */
export function routePickedFiles(files, hasPhotos) {
  const videos = files.filter(isVideoFile);
  if (videos.length === 0) {
    return { kind: 'photos', files };
  }
  if (files.length === 1 && !hasPhotos) {
    return { kind: 'video', file: videos[0] };
  }
  return { kind: 'refused' };
}
